
  var _styles = {
  "flight-theme-2": {
    "width": "100%"
  },
  "flight-theme-2_list": {
    "width": "100%",
    "height": "3.25333rem",
    "background": "#fff",
    "position": "relative",
    "padding": "0.4rem",
    "marginTop": "-0.01333rem",
    "marginRight": 0,
    "marginBottom": "-0.01333rem",
    "marginLeft": 0
  },
  "flight-theme-2_list_list-img": {
    "position": "absolute",
    "left": "0.4rem",
    "top": "0.4rem",
    "display": "block",
    "width": "3.2rem",
    "height": "2.45333rem",
    "borderRadius": "0 !important"
  },
  "flight-theme-2_list_discount": {
    "position": "absolute",
    "left": "0.4rem",
    "top": "0.4rem",
    "paddingTop": 0,
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "height": "0.42667rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "color": "rgb(255,255,255)",
    "background": "#fb6544"
  },
  "flight-theme-2_list_discount_discount-text": {
    "fontSize": "0.29333rem",
    "fontFamily": "PingFangSC-Regular"
  },
  "flight-theme-2_list_purchaserCount": {
    "position": "absolute",
    "left": "0.4rem",
    "bottom": "0.4rem",
    "width": "3.2rem",
    "height": "0.42667rem",
    "lineHeight": "0.42667rem",
    "paddingLeft": "0.13333rem",
    "background": "rgba(51,51,51,.7)",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.24rem",
    "color": "rgb(255,255,255)"
  },
  "flight-theme-2_list_right": {
    "height": "2.45333rem",
    "position": "relative",
    "width": "100%",
    "paddingLeft": "3.6rem"
  },
  "flight-theme-2_list_right_flight-city": {
    "height": "0.56rem",
    "lineHeight": "0.56rem",
    "marginBottom": "0.08rem",
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.4rem",
    "color": "rgb(51,51,51)",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap"
  },
  "flight-theme-2_list_right_flight-depart": {
    "height": "0.44rem",
    "lineHeight": "0.44rem",
    "marginBottom": "0.16rem",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)"
  },
  "flight-theme-2_list_right_x-product-wrap": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem"
  },
  "flight-theme-2_list_right_x-product-wrap_span": {
    "height": "0.42667rem",
    "lineHeight": "0.42667rem",
    "paddingTop": 0,
    "paddingRight": "0.14667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.14667rem"
  },
  "flight-theme-2_list_right_x-product-wrap_ticket": {
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(21,203,46)",
    "color": "rgb(21,203,46)"
  },
  "flight-theme-2_list_right_x-product-wrap_label-word": {
    "borderRadius": "0.05333rem",
    "fontSize": "0.24rem",
    "fontFamily": "PingFangSC-Medium",
    "height": "0.37333rem",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem",
    "marginLeft": "0.02667rem"
  },
  "flight-theme-2_list_right_x-product-wrap_label-img": {
    "height": "0.42667rem",
    "marginLeft": "0.02667rem",
    "position": "relative",
    "top": "0.10667rem"
  },
  "flight-theme-2_list_right_price-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center",
    "position": "absolute",
    "left": "3.6rem",
    "bottom": 0,
    "height": "0.46667rem",
    "fontFamily": "PingFangSC-Semibold",
    "color": "rgb(251,101,68)"
  },
  "flight-theme-2_list_right_price-wrap_price-sym": {
    "fontSize": "0.26667rem"
  },
  "flight-theme-2_list_right_price-wrap_price": {
    "fontFamily": "Helvetica-Bold",
    "fontSize": "0.48rem"
  },
  "flight-theme-2_list_right_price-wrap_person": {
    "fontSize": "0.4rem",
    "marginLeft": "0.06667rem"
  },
  "flight-theme-2_list_right_btn": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "width": "1.94667rem",
    "height": "0.88rem",
    "lineHeight": "0.88rem",
    "textAlign": "center",
    "background": "#fb6544",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)"
  }
};



  module.exports = _styles;
  